module.exports = require("commonmark");


//////////////////
// WEBPACK FOOTER
// external "commonmark"
// module id = 586
// module chunks = 0